import PrimeTableSimple from "../utilities/table/primeTableSimple";


function ViewLearnerPathway(props) {

  // Define variables
  const pathway = props.pathway;
  const dataInitial = pathway.lessons;
  const firstName = props.firstName;
  // const isIelts = pathway.isIelts;
  // const score = pathway.score;
  const showResponses = props.showResponses;
  const columns = props.columns;
  const allowExpansion = props.allowExpansion;
  const rowExpansionTemplate = props.rowExpansionTemplate;
  const filename = `Lesson Data - ${pathway.title} - ${firstName}`;

  // Format date & time
  const data = [];
  dataInitial.forEach((lesson, index) => {
    if( lesson.date ) {
      const thisDate = new Date(lesson.date);
      lesson.date = thisDate;
    }
    lesson.time = lesson.time.replace('minute', 'min');
    data.push(lesson);
  });


  // Screen components
  let dateWord = 'Started';
  let date = pathway.createdAt;
  if( pathway.status === 'Complete' ) {
    dateWord = 'Completed';
    date = pathway.updatedAt;
  } else if( pathway.status === 'cancelled' ) {
    dateWord = 'Cancelled';
    date = pathway.updatedAt;
  }


  return (
    <div style={{marginBottom: '60px'}}>
      <h4>{pathway.title}</h4>
      <p>Status: {pathway.status}</p>
      {/* {scoreElement} */}
      <p class="gray-text seconday-info" style={{fontSize: '.9rem'}}>
        {pathway.lessonsCompleted}
        <span style={{marginLeft: '1px', marginRight: '1px'}}>/</span>
        {pathway.lessonTotal} lessons completed
      </p>
      <p class="gray-text seconday-info" style={{marginBottom: '15px', fontSize: '.9rem'}}>
        {dateWord} {date}
      </p>

      <PrimeTableSimple
        columns={columns}
        data={data}
        allowExpansion={allowExpansion}
        rowExpansionTemplate={rowExpansionTemplate}
        searchPlaceholder={'Search by code, name, or email'}
        showResponses={showResponses}
        showExport={true}
        filename={filename}
      />

    </div>
  );
}

export default ViewLearnerPathway;